import React from 'react';
import { useTranslation } from 'react-i18next';

const renderSource = source => {
  const { source_name, agreements } = source;
  return agreements.map((agreement) => renderAgreement(source_name, agreement))
}

const renderAgreement = (sourceName, agr) => {
  const { agreement = '', arbetsgivarorganisation = '' } = agr;
  return (
    <tr>
      <td>{sourceName}</td>
      <td>{agreement}</td>
      <td>{arbetsgivarorganisation}</td>
    </tr>
  );
}
export default function CollectiveAccordion({ data }) {
  const [t] = useTranslation('supplierDatabase', { keyPrefix: 'supplierControls.collectiveAgreement.details' });
  const { kollektivavtalskollen, byggInstSektorn } = data;
  const companyName = kollektivavtalskollen.source_data?.length && kollektivavtalskollen.source_data[0].company_name;
  return (
    <div className="collectiv-drawer-inner">
      <h2 className="collectiv-drawer-title" title={companyName}>
        <b>{t('heading', 'Kollektivavtal')}</b> {companyName}
      </h2>

      <h3>{t('kollektivavtalskollen.heading', 'Information från Kollektivavtalskollen')}<sup>1</sup></h3>

      {kollektivavtalskollen.error ? (
        <p>{t('errorMessage', 'Kunde inte hämta data: {{error}}', { error: kollektivavtalskollen.error })}</p>
      ) : (
        <table style={{width: "100%", fontSize:"14px"}}>
          <tr>
            <th>{t('table.header.sourceName', 'Fackförbund')}</th>
            <th>{t('table.header.agreement', 'Avtal')}</th>
            <th>{t('table.header.arbetsgivarorganisation', 'Arbetsgivarorganisation')}</th>
          </tr>
          {kollektivavtalskollen.source_data.map(source => renderSource(source))}
        </table>
      )}

      <h3>{t('byggInstSektorn.heading', 'Bygg- och installationssektorn')}<sup>2</sup></h3>

      {byggInstSektorn.error ? (
        <p>{t('errorMessage', 'Kunde inte hämta data: {{error}}', { error: byggInstSektorn.error })}</p>
      ) : (<>
        {byggInstSektorn.memberships.length > 0 && (
          <p style={{marginTop: 0}}>
            {t('byggInstSektorn.memberships', 'Medlem i {{memberships_list}}.', { memberships: byggInstSektorn.memberships.map(m => m.name) })}
          </p>
        )}
        <table style={{width: "100%", fontSize:"14px"}}>
          <tr>
            <th>{t('table.header.sourceName', 'Fackförbund')}</th>
            <th>{t('table.header.agreement', 'Avtal')}</th>
            <th>{t('table.header.arbetsgivarorganisation', 'Arbetsgivarorganisation')}</th>
          </tr>
          {byggInstSektorn.collectiveAgreements.map(c => (
            <tr>
              <td>{c.FackligMotpart}</td>
              <td>{c.Avtal}</td>
              <td>{c.Medlemsorganisation}</td>
            </tr>
          ))}
          {byggInstSektorn.substituteAgreements.map(c => (
            <tr>
              <td>{c.FackligMotpart}</td>
              <td>{c.Avtal}</td>
              <td>{t('table.row.substituteAgreement', '(hängavtal)')}</td>
            </tr>
          ))}
        </table>
      </>)}

      <p><sup>1</sup> {t('kollektivavtalskollen.description', 'Kollektivavtalskollen innehåller information från fackförbunden och inkluderar avtal med Byggnads, Kommunal, Fastighet, Elektrikerna, Handels, Målarna, Akavia, Forena och Finansförbundet (fler förbund/avtal kommer, denna lista är senast uppdaterad 2024-08-21).')}</p>
      <p style={{marginTop: "0px"}}><sup>2</sup> {t('byggInstSektorn.description', 'Bygg- och installationssektorn innehåller information från arbetsgivarorganisationer och inkluderar medlemskap, kollektivavtal och hängavtal från Byggföretagen, Installatörsföretagen, Maskinentreprenörerna, Plåt & Ventföretagen, Måleriföretagen och Glasbranschföreningen.')}</p>
    </div>
  );
}
